import { Content, Row, Col, Button, H1, H2, H3 } from 'components/common'
import { React, Image, styled, mq } from 'x'
import { Link } from 'gatsby'
import Arrow from 'static/svg/arrow.svg'

const Container = styled.div`
box-sizing: border-box;
  display: block;
  padding: 60px 30px;
  margin-left:auto;
  margin-right:auto;
  margin-top:0;
  margin-bottom:0;
`

const SectionContent = styled(Content)`
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  padding: 0 30px;

  ${mq.below('lg')} {
    padding: 0 30px;
  }
  ${mq.below('md')} {
    padding: 0 30px;
  }
  ${mq.below('sm')} {
    padding: 0 15px;
  }
`

const Title = styled(H1)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 30px;
  font-size:42px;
  line-height: 1.2;
  font-weight:800;
`

const Subtitle = styled(H2)`
  max-width: 100%;
  color: #000;
  text-align:center;
  width: 100%;
  margin-top:0;
  margin-bottom: 30px;
  font-size:36px;
  line-height:1.2;
  font-weight:600;
`

const Inner = styled.div`
  ${mq.above('lg')} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  box-sizing: border-box;
  margin-right: -30px;
  margin-left: -30px;
  margin-top:30px;
  display:flex;
  flex: 0 1 auto;
  flex-direction:column;
  align-items:stretch;
  align-content:stretch;
`

const Tile = styled.div`
  ${mq.above('lg')} {
    flex:1 1 33.3336%;
    max-width:33.3336%;
    margin-bottom:0;
  }
  box-sizing: border-box;
  flex:1 1 100%;
  max-width: 100%;
  padding:0 30px;
  margin-bottom:30px;
  align-items:center

  a {
    display:block;
    width:100%;
    height:100%;
    box-sizing: border-box;
  }
`

const TileInner = styled.div`
  ${mq.above('lg')} {
    min-height:430px;
  }
  display:block;
  padding:30px;
  background-color: #fff;
  height:100%;
`

const TileImgWrapper = styled.div `
  margin-bottom:30px;
  img, Image {
    margin:0 auto;
    width:100%;
    max-width: 100%;
    height:auto;
  }
`

const TileContent =styled.div`
  text-align: center;
  display:block;
`

const TileTitle =styled(H3) `
  color:#000;
  font-size:24px;
  font-weight:800;
  line-height:1.2;
  margin-top:0;
  margin-bottom:10px;
`

const TileSubtitle = styled.p`
  font-size: 18px;
  line-height: 1.2;
  color: #000;
  margin: 30px 0;
  font-weight: 500;
  margin-top:0;
  margin-bottom:0;
`

const Section = props => {
  const items = props.data.items
    ? props.data.items
    : [
        {
          bgColour: props.data.items.bgColour,
          image: props.data.items.image.imgixImageWp.fluid,
          imageLocal: props.data.items.image.source_url,
          title: props.data.items.title,
          subtitle: props.data.items.subtitle,
          link: props.data.items.link,
        }
      ]

  const numTiles = items.length


  return (
    <Container style={{backgroundColor: props.data.bgColour || 'black' }}>
      <SectionContent>
        <Row>
          <Col>
            <Title>{props.data.title}</Title>
            <Subtitle>{props.data.subtitle}</Subtitle>
          </Col>
        </Row>
          <Inner index={props.index} numTiles={numTiles}>
            {items.map((item, index) => (
              <Tile key={'item-' + index}>
                <Link to={item.link} style={{display: 'block', width: '100%'}}>
                  <TileInner>
                    <TileImgWrapper>
                      {item?.image?.imgixImageWp?.fluid && (
                          <Image
                            fluid={{ ...item.image.imgixImageWp.fluid, sizes: '100vw' }}
                          />
                      )}
                    </TileImgWrapper>
                    <TileContent>
                      {item.title && (<TileTitle>{item.title}</TileTitle>)}
                      {item.subtitle && (<TileSubtitle>{item.subtitle}</TileSubtitle>)}
                    </TileContent>
                  </TileInner>
                </Link>
              </Tile>
            ))}
          </Inner>
      </SectionContent>
    </Container>
  )
}

export default Section
